import Highcharts from 'highcharts/highcharts';
import getJSON from '~/js/helpers/xhr';
import {getDateInFormat} from '~/js/helpers/date-helpers';
// Todo удалить библиотеку Pikaday
// import Pikaday from "pikaday";


export default class PieChart {
  constructor({chart, options}) {
    this._element = chart;
    this._options = options;
    this._originalOptions = Highcharts.merge(this._options);

    this._chart = this._element.querySelector(`.js-pie-chart`);
    this._resId = this._chart.getAttribute("data-res-id");
    this._action = this._chart.getAttribute("data-action");
    this._legend = this._element.querySelector(`.js-pie-legend`);
    this._downloadLink = this._legend.querySelector('.js-download-xlsx-link');
    this._downloadLinkBlock = this._legend.querySelector('.js-pie-dl-block');
    this._downloadLinkInput = this._downloadLinkBlock.querySelector('.js-pie-chart-datepicker');

    this._instance = null;

    this._setResponsiveOptions = this._setResponsiveOptions.bind(this);
    this._downloadLinkChangeHundler = this._downloadLinkChangeHundler.bind(this);

    this.init();
  }

  _setResponsiveOptions() {
    const updatedOptions = window.innerWidth >= 1024 ?
      Highcharts.merge(this._originalOptions, this._originalOptions.responsiveRules) :
      Highcharts.merge(this._originalOptions.responsiveRules, this._originalOptions);

    this._instance.update(updatedOptions);
  }

  _addElement(name, value, color, lev, num, data, is_child, index) {
    const element = document.createElement(`DIV`);
    let lev_class = lev ? lev : '';
    let lev_num = num ? num : '';
    let lev_data = data ? 'data-filter="' + data + '"' : '';
    let lev_button = is_child ? '<p class="clr-text t-normal charts__legend-button"></p>' : '';
    let active = index ? '' : 'active';
    element.innerHTML = `
    <div class="charts__legend-item ${active} ${lev_class} ${lev_num}" ${lev_data} style="color: ${color}">
      <span class="chart-pin"></span>
      <p class="clr-black t-normal charts__legend-name">${name}</p>
      <p class="clr-text t-normal charts__legend-value">${Highcharts.numberFormat(value, 2, '.')}%</p>
      ${lev_button}
    </div>`;
    return element.firstElementChild;
  }

  _initLegend() {
    const items = this._instance.series[0] ? this._instance.series[0].data : null;
    const fragment = document.createDocumentFragment();
    let name;
    let value;
    let color;

    if (items) {
      items.forEach((item1, i1) => {
        name = item1.name;
        value = +item1.percentage.toFixed(2);
        color = item1.color;
        fragment.appendChild(this._addElement(name, value, color, 'lev1', '', 'lev1-' + (i1+1), item1['items'].length, i1));
      });
    }
    this._legend.insertBefore(fragment, this._downloadLinkBlock);
  }

  _setDownloadLinkXlsxDate(date) {
    if(this._downloadLink) {
      let url = new URL(this._downloadLink.href);
      let urlParams = new URLSearchParams(url.search.slice(1));
      urlParams.set('date', date / 1000);
      this._downloadLink.href = this._downloadLink.href.split('?')[0] + '?' + urlParams.toString();
    }
  }

  _downloadLinkChangeHundler(e) {
    let date = new Date(e.target.value).getTime();
    let maxDate = new Date(this._downloadLinkInput.max).getTime();
    let minDate = new Date(this._downloadLinkInput.min).getTime();
    // проверить, если дата входит в допустимый  диапазон
    if (date <= maxDate && date >= minDate ) {
      this._setDownloadLinkXlsxDate(date);
    } else {
      alert("Для ввода даты используйте календарь!");
    }
  }

  init() {

    let pieChartColors = undefined;
    let pieChartSeries = undefined;
    let element = this._element;

    const title = document.querySelector(`.content-header__title`);

    if (this._resId) {

      getJSON(`assets/components/dohod/connectorweb.php?resId=${this._resId}&action=${this._action}`).then((fs_data) => {

        if(this._downloadLinkInput) {
          // корректировка ссылки на скачивание
          this._setDownloadLinkXlsxDate(fs_data.maxDate * 1000);
          // инициализация параметров для календаря
          let maxDate = new Date(fs_data.maxDate * 1000);
          let minDate = new Date(fs_data.minDate * 1000);
          this._downloadLinkInput.value = this._downloadLinkInput.max = getDateInFormat(maxDate, 'Y-m-d');
          this._downloadLinkInput.min = getDateInFormat(minDate, 'Y-m-d');

          // изменение поле календаря
          this._downloadLinkInput.addEventListener(`change`, this._downloadLinkChangeHundler);

        }

        pieChartSeries = [{
          name: title ? title.textContent : `Доля`,
          data: fs_data.items.map((item, i) => ({
            name: item.title,
            y: +item.percent,
            color: item.color,
            selected: i === 0 ? true : false,
            sliced: i === 0 ? true : false,
            items: item.items ? item.items : null,
          })),
          showInLegend: true,
        }];

        pieChartColors = pieChartSeries[0].data.map((item) => item.color);

        this._options.series = pieChartSeries;
        this._options.colors = pieChartColors;
        this._options.plotOptions.pie.events.click = function(evt) {

          const value = Highcharts.numberFormat(evt.point.percentage, 2, '.');
          this.chart.title.textStr = value;
          this.chart.title.element.textContent = `${value}%`;


          const legendItems = document.querySelectorAll(`.charts__legend-item`);
          if (legendItems.length) {
            legendItems.forEach((legendItem) => {
              legendItem.classList.remove('active');
            });
            legendItems[evt.point.index].classList.add(`active`);
          }

        };

        this._instance = Highcharts.chart(this._chart, this._options);

        this._setResponsiveOptions();
        this._initLegend();

        window.addEventListener(`resize`, this._setResponsiveOptions);

        const legendItems = this._element.querySelectorAll(`.charts__legend-item`);
        if (legendItems.length) {
          legendItems.forEach((legendItem, legendIndex)  => {
            legendItem.addEventListener(`click`, (event) => {
              legendItems.forEach((legendItem) => {
                legendItem.classList.remove('active');
              });
              let el = event.currentTarget;
              el.classList.toggle("active");

              this._element.querySelectorAll(`.highcharts-point`).forEach((pointItem, pointIndex) => {
                pointItem.classList.remove('highcharts-point-select');
              });

              if(this._instance.series[0].data.length) {
                this._instance.series[0].data.forEach((instanseItem, instanseIndex) => {
                  this._instance.series[0].data[instanseIndex].selected = false;
                  this._instance.series[0].data[instanseIndex].sliced = false;
                });
                this._instance.series[0].data[legendIndex].selected = true;
                this._instance.series[0].data[legendIndex].sliced = true;
                this._setResponsiveOptions();
              }
            });
          });
        }
      });
    }
  }
}
